import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  AbsenceType,
  AbsenceTypeList,
  FetchedAbsenceType,
} from '@lmc/ts-common'
import {
  ABSENCE_TYPE_UPDATE_QUERY_KEY,
  ABSENCE_TYPES_QUERY_KEY,
  ABSENCE_TYPES_URL,
} from './queryConstants'

type UseAbsenceTypesUpdateProps = {
  onSuccess?: () => void
}

type UseAbsenceTypesUpdateReturn = {
  updateAbsenceTypes: (obj: { types: AbsenceType[] }) => void
  isUpdateAbsenceTypesLoading: boolean
}

export const useAbsenceTypesUpdate = ({
  onSuccess,
}: UseAbsenceTypesUpdateProps): UseAbsenceTypesUpdateReturn => {
  const queryClient = useQueryClient()

  // UPDATE
  const updateFunction = (values: { absenceTypes: AbsenceTypeList }) =>
    postJSON({
      url: ABSENCE_TYPES_URL,
      method: 'PUT',
      isRota: true,
      json: values,
    })

  const {
    mutateAsync: updateAbsenceTypes,
    isLoading: isUpdateAbsenceTypesLoading,
  } = useMutation<FetchedAbsenceType, unknown, any>(
    [ABSENCE_TYPE_UPDATE_QUERY_KEY],
    updateFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ABSENCE_TYPES_QUERY_KEY)
        onSuccess?.()
      },
    }
  )

  return {
    updateAbsenceTypes,
    isUpdateAbsenceTypesLoading,
  }
}
